import React, { useState } from "react";
import { useCaptcha } from "@repoflow/components/captcha";
import * as CaptchaLib from "@repoflow/browser/captcha";
import AuthSchema from "@common/schema/auth";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router';
import * as Loading from "@repoflow/components/loading";
import { Component as Form } from "@repoflow/form-schema";
import { Container, Col, Row, Alert } from "reactstrap";
import * as Section from "@repoflow/components/section";
import { gql } from "@apollo/client";
import { QueryContent } from "@repoflow/components/content-query-anonymous";
import { basename } from "env";
import * as AuthQL from "queries/auth";

const MUTATION = gql`
  mutation Login($domainId: String!, $orgId: String, $email: String!, $password: String!, $token: String!) {
    viewer {
      anonymous(token: $token) {
        auth {
          login(domainId: $domainId, orgId: $orgId, email: $email, password: $password) {
            id
            email
            domain
            token
          }
        }
      }
    }
  }
`;







// The session query declares $domainId: String!, so a missing parameter fails
// variable validation and used to replace the whole page with a raw GraphQL
// error string. The same message covers a domainId that resolves to nothing.
export const MissingDomain = () => (
  <Container className="mt-4">
    <Row>
      <Col>
        <Alert color="danger">
          This sign-in link is incomplete — it does not say which domain to sign
          you in to. Please use the link you were given, or contact support.
        </Alert>
      </Col>
    </Row>
  </Container>
);

export default function () {
  const location = useLocation();
  const domainId = new URLSearchParams(location.search).get("domainId");

  if (!domainId) {
    return <MissingDomain />;
  }

  return (
    <QueryContent query={AuthQL.session} variables={{ domainId }}>
      {ContentHandler}
    </QueryContent>
  );
}


const ContentHandler = ({ anonymous, variables: { domainId }, error }) => {
  const session = anonymous.auth.session;
  // Which of the caller's organizations on this domain to sign in to. attach and
  // validate both land here with it; without it the API takes the first one.
  const orgId = new URLSearchParams(useLocation().search).get("orgId") || null;
  const [phase, setPhase] = useState("init");
  const { publicKey, ready } = useCaptcha();

  if (!ready) {
    return <Loading.Content />;
  }

  // AnonymousAuthSession is nullable: an unknown domainId resolves to null and
  // reading session.description off it took the page down with it.
  if (!session) {
    return <MissingDomain />;
  }

  return (
    <Section.Provider schema={AuthSchema}>
      <Section.Mutation
        guard={false}
        context={{ session, domainId, phase }}
        initial={{ email: "", password: "" }}
        mutation={MUTATION}
        schema={AuthSchema}
        target={{ $ref: "/Input/Login/UI" }}
        onMutate={({ handler, state: { values } }) => {
          const { email, password } = values;

          setPhase("init");
          CaptchaLib.request(publicKey, (token) => {
            handler({
              variables: {
                domainId,
                orgId,
                email,
                password,
                token
              },
            });
          });
        }}
        onError={(error) => {
          setPhase("error");
        }}
        onCompleted={(data) => {
          const { domain, token } = data.viewer.anonymous.auth.login
          window.location = `https://${domain}${basename}/auth/callback?token=${encodeURIComponent(token)}`;
        }}
      >
        {MutationHandler}
      </Section.Mutation>
    </Section.Provider>
  );
};

const MutationHandler = ({
  schema,
  target,
  state: { values, isValid, setValues },
  error,
  context: { session, domainId, phase }
}) => {
  const formProps = {
    schema,
    target,
    values,
    onChange: (values) => {
      setValues(values);
    },
    config: {
      "/Input/Login/UI": {
        fields: [
          {
            label: "Email",
            property: "email",
          },
          {
            label: "Password",
            property: "password",
            password: true,
          }
        ]
      },
    },
  };

  return (
    <>
    <Container className="mt-4">
      <Row>
        <Col className="text-center">
          <div className="mt-4"></div>
          Sign in to <h1><b>{session.description}</b></h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="mt-4"></div>
          <Form {...formProps} >
              <Section.Button type={"submit"}>Sign In</Section.Button>
            </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          {phase === "error" && (
            <Alert color="danger">Incorrect email or password.</Alert>
          )}

        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          <Link to={`/auth/forgot?domainId=${encodeURIComponent(domainId)}`}>Forgot your password?</Link>
        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          <Link to={`/auth/register?domainId=${encodeURIComponent(domainId)}`}>Sign up</Link> if you don't have an account
        </Col>
      </Row>
    </Container>
    </>
  );
};


